import React, { useState, useEffect } from 'react'
import './App.css'
import { QueryClient, QueryClientProvider } from 'react-query'
import { TbArrowBackUp } from 'react-icons/tb'
import { useNavigate } from 'react-router'

import { useLocation } from 'react-router-dom'
import { IoCloseSharp } from 'react-icons/io5'
import { FaVideo } from 'react-icons/fa'

const data = [
  {
    title: '네이버 주문 UI 개선',
    date: '2024',
    descriptions: [
      '메뉴 목록 영역 중 상위 영역 담당',
      '오타 방지를 위해 cspell 적용',
      '일부 SSR 안되는 컴포넌트 수정',
      'localStorage, sessionStorage 관리 로직 적용',
    ],
    images: [
      {
        src: 'https://ik.imagekit.io/crso3ztbifq/portfolio/KakaoTalk_Video_2025-02-14-18-56-38_XSj5zf9tV.mp4?updatedAt=1739527077967',
        description: '개선된 주문 UI 예시',
        type: 'video',
        id: 0,
      },
      {
        src: 'https://ik.imagekit.io/crso3ztbifq/portfolio/KakaoTalk_Photo_2025-02-14-18-56-29%20002_MKgF9sqV8E.jpeg?updatedAt=1739527075418',
        description: '메뉴 목록 페이지',
        type: 'image',
        id: 1,
      },
      {
        src: 'https://ik.imagekit.io/crso3ztbifq/portfolio/KakaoTalk_Photo_2025-02-14-18-56-29%20006_gssI8A3io.jpeg?updatedAt=1739527076020',
        description: '메뉴 상세 페이지',
        type: 'image',
        id: 2,
      },
      {
        src: 'https://ik.imagekit.io/crso3ztbifq/portfolio/KakaoTalk_Photo_2025-02-14-18-56-29%20003_gadf5KAez.jpeg?updatedAt=1739527075492',
        description: '주문서 페이지',
        type: 'image',
        id: 3,
      },
    ],
  },
  {
    title: '실시간교통상황 개편',
    date: 'Apr 2024 - Aug 2024',
    descriptions: [
      '동료 2명과 같이 작업. 약 2달 소요',
      'koa로 이용하여 ssr 렌더링 구현',
      'SSR 렌더링 성능 최적화. 250ms 이하',
    ],
    images: [
      {
        src: 'https://ik.imagekit.io/crso3ztbifq/portfolio/%E1%84%89%E1%85%B3%E1%84%8F%E1%85%B3%E1%84%85%E1%85%B5%E1%86%AB%E1%84%89%E1%85%A3%E1%86%BA%202024-09-15%20%E1%84%8B%E1%85%A9%E1%84%8C%E1%85%A5%E1%86%AB%2011.53.11_ZZJV2OtzK.png?updatedAt=1726368965425',
        description: '네이버 첫 화면에서 실시간 교통상황 검색 시 노출되는 UI',
        type: 'image',
        id: 4,
      },
      {
        src: 'https://ik.imagekit.io/crso3ztbifq/portfolio/%E1%84%89%E1%85%B3%E1%84%8F%E1%85%B3%E1%84%85%E1%85%B5%E1%86%AB%E1%84%89%E1%85%A3%E1%86%BA%202024-09-15%20%E1%84%8B%E1%85%A9%E1%84%8C%E1%85%A5%E1%86%AB%2011.53.45_-8wMTy2vG.png?updatedAt=1726368965544',
        description: '두번째 탭',
        type: 'image',
        id: 5,
      },
      {
        src: 'https://ik.imagekit.io/crso3ztbifq/portfolio/%E1%84%89%E1%85%B3%E1%84%8F%E1%85%B3%E1%84%85%E1%85%B5%E1%86%AB%E1%84%89%E1%85%A3%E1%86%BA%202024-09-15%20%E1%84%8B%E1%85%A9%E1%84%8C%E1%85%A5%E1%86%AB%2011.54.21_nBrKnz2-h.png?updatedAt=1726368965302',
        description: '특정 도로 상세 페이지',
        type: 'image',
        id: 6,
      },
      {
        src: 'https://ik.imagekit.io/crso3ztbifq/portfolio/%E1%84%89%E1%85%B3%E1%84%8F%E1%85%B3%E1%84%85%E1%85%B5%E1%86%AB%E1%84%89%E1%85%A3%E1%86%BA%202024-09-15%20%E1%84%8B%E1%85%A9%E1%84%8C%E1%85%A5%E1%86%AB%2011.54.41_pcTfGgYCH.png?updatedAt=1726368964973',
        description: '교통사고 상세 페이지',
        type: 'image',
        id: 7,
      },
    ],
  },
  {
    title: 'Yahoo Japan Place',
    date: 'Nov 2022 - Apr 2024',
    descriptions: [
      '외부 서비스 제공을 위하여 미디어 뷰어 페이지 설계 및 개발',
      '외부플렛폼 장애 시 Circuit Breaker로 인하여 서버 부하가 최소화 되고 유저에게 적절한 UI가 빠르게 노출',
    ],
    images: [
      {
        src: 'https://ik.imagekit.io/crso3ztbifq/portfolio/KakaoTalk_20240327_165959735_hZQfRShMV.mp4?updatedAt=1711545171706',
        description:
          '단풍 & 벚꽃 시즌 때 명소 페이지 진입 시 단풍 및 벚꽃 떨어지는 에니메이션 개발',
        type: 'video',
        id: 10,
      },
      {
        src: 'https://ik.imagekit.io/crso3ztbifq/portfolio/yj_menu_tab_HsmZ80G3t.mp4?updatedAt=1711584926664',
        description: '메뉴 탭 페이지',
        type: 'video',
        id: 8,
      },
      {
        src: 'https://ik.imagekit.io/crso3ztbifq/portfolio/yj_menuend_Dzo7wGzPa.mp4?updatedAt=1711584807919',
        description: '메뉴 페이지',
        type: 'video',
        id: 9,
      },
      {
        src: 'https://ik.imagekit.io/crso3ztbifq/portfolio/yj_reviewend_TzN_0oijs.mp4?updatedAt=1711584929193',
        description: '리뷰 페이지 개발',
        type: 'video',
        id: 11,
      },
    ],
  },
  {
    title: 'Line Place',
    date: 'Nov 2021 - Nov 2022',
    descriptions: [
      '지역 X 카테고리 랭킹 API + 페이지 개발 + 랭킹 품질 검증 배치 개발',
      '랭킹 품질 검증 배치 개발',
      'LCP(Largest Contentful Paint) 최적화',
      'Tree-shaking 적용하여 bundle size 최소화',
      'GraphQL Dataloader level에서 Redis 이용하여 API 캐쉬 적용 (하나의 영수증에 많은 리뷰가 작성된 경우)',
      'SEO 개선',
    ],
    images: [
      {
        src: 'https://ik.imagekit.io/crso3ztbifq/portfolio/lp_ranking_2FIvyGnxn.mp4?updatedAt=1711585941716',
        description: '명소 페이지',
        type: 'video',
        id: 12,
      },
    ],
  },
  {
    title: 'Vlive',
    date: 'Nov 2021 - Nov 2022',
    descriptions: [
      'Slow 3G 환경, 3rd party sdk 로드되기전 sdk API 호출되어 404 에러 발생하여 수정',
      'JS, CSS 파일 Static File Server에 올려, 웹 초기 렌더링 속도 향상',
      '유료 채팅 페이지 개발. 구매 권한 체크를 위해 JWT 사용',
      '이미지 업로드 시 BFF에 전달하고 BFF가 이미지 SDK API 호출하여 비효율. BFF 의존성을 제거되고 글로벌 대응도 가능하게 됨',
      '쿠키 정책 변경으로 특정 브라우저에서 로그인이 안되었던 이슈 최대한 해결',
    ],
    images: [
      {
        src: 'https://ik.imagekit.io/crso3ztbifq/notifications_gif_2_ApeLQUg-0.gif?updatedAt=1621132744719',
        description: '새소식 UI 개발',
        type: 'image',
        id: 16,
      },
      {
        src: 'https://ik.imagekit.io/crso3ztbifq/v_channelHome_TfR9vC-sP1.gif?updatedAt=1626010520165',
        description: '채널 홈 UI 개발',
        type: 'image',
        id: 17,
      },
      {
        src: 'https://ik.imagekit.io/crso3ztbifq/channelMy__d9Cau--rG.gif?updatedAt=1617093073381',
        description: '채널 My UI 개발',
        type: 'image',
        id: 18,
      },
      {
        src: 'https://ik.imagekit.io/crso3ztbifq/channel_chat_1_aDBboBrjXG.gif?updatedAt=1632538868031',
        description: '유료 채팅 페이지 1',
        type: 'image',
        id: 13,
      },
    ],
  },
  {
    title: 'WAV Media',
    date: 'Aug 2016 - Jan 2020',
    descriptions: [
      '웹 SPA 적용 (from jQuery to React)',
      'Varnish 서버로 웹페이지 캐싱하여 비로그인 유저에게 빠르게 HTML 렌더링',
      '채널, 비디오, 태그 데이터를 색인하고 검색하는 과정 모두 진행',
      '비디오 재생 페이지에 추천 영상 리스트 UI 개발',
      '마케팅 툴 연동 (Braze, Facebook Pixel, Tune, GA)',
      'Lambda Architecture 기반 실시간 사용자 엑션에 의한 레벨 증가 시스템 개발',
      'Ansible 이용하여 인프라 구축 (Static File Server, 운영툴, Redis)',
    ],
  },
]

/**
 * https://reactjs-kr.firebaseapp.com/docs/typechecking-with-proptypes.html
 * @returns {JSX.Element}
 * @constructor
 */
function Detail() {
  const queryClient = new QueryClient()
  const location = useLocation()
  const navigate = useNavigate()
  const [selectedImage, setSelectedImage] = useState(null)
  const hash = location.hash

  // 컴포넌트 마운트 시 해시가 있다면 해당 이미지 표시
  useEffect(() => {
    if (hash) {
      const images = data
        .map((item) => item.images)
        .filter(Boolean)
        .flat()
      const image = images.find((img) => img.id === parseInt(hash))
      if (image) setSelectedImage(image)
    } else {
      setSelectedImage(null)
    }
  }, [hash])

  const handleBack = () => {
    if (location.state?.fromHome) {
      window.history.back()
    } else {
      navigate('/')
    }
  }

  const handleImageClick = (image) => {
    setSelectedImage(image)
    window.location.hash = image.id
  }

  const handleCloseModal = () => {
    setSelectedImage(null)
    navigate(location.pathname) // 해시 제거
  }

  function renderContent(item) {
    const { title, date, descriptions, images = [] } = item
    return (
      <div key={title}>
        <div className={`detail-container`}>
          <div className="detail-container-left">
            <h3>{title}</h3>
            <span>{date}</span>
          </div>
        </div>
        <div className={`hidden-info open`}>
          <ul className="hidden-info-list">
            {descriptions.map((description, index) => (
              <li key={index}>{description}</li>
            ))}
          </ul>
        </div>
        <div className="image-container">
          {Array.from(
            { length: Math.ceil(images.length / 2) },
            (_, rowIndex) => (
              <div key={rowIndex} className="image-row">
                {images
                  .slice(rowIndex * 2, rowIndex * 2 + 2)
                  .map((image, index) => (
                    <div
                      key={index}
                      className="image-wrapper"
                      onClick={() => handleImageClick(image)}
                    >
                      {image.type === 'video' ? (
                        <div className="video-container">
                          <video src={image.src} />
                          <FaVideo className="video-icon" />
                        </div>
                      ) : (
                        <img
                          src={image.src}
                          alt={`이미지 ${rowIndex * 2 + index + 1}`}
                        />
                      )}
                      <div className="image-description">
                        {image.description}
                      </div>
                    </div>
                  ))}
              </div>
            ),
          )}
        </div>
      </div>
    )
  }
  return (
    <QueryClientProvider client={queryClient}>
      {data.map((item) => renderContent(item))}
      {selectedImage && (
        <div className="modal">
          <button className="close-btn" onClick={handleCloseModal}>
            <IoCloseSharp />
          </button>
          <div className="modal-content">
            {selectedImage.type === 'video' ? (
              <video src={selectedImage.src} autoPlay muted />
            ) : (
              <img src={selectedImage.src} alt="확대된 이미지" />
            )}
          </div>
          <div className="modal-description">{selectedImage.description}</div>
        </div>
      )}
      {!selectedImage && (
        <button className="floating-back-btn" onClick={handleBack}>
          <TbArrowBackUp />
        </button>
      )}
    </QueryClientProvider>
  )
}

export default Detail
